import { useEffect } from 'react'
import { requestForToken, onMessageListener } from '../lib/firebase'
import { toast } from 'sonner'
import { buildBackendUrl } from '../lib/backend-url'

export function useFCM(userId) {
  useEffect(() => {
    if (!userId) return

    const setupFCM = async () => {
      const authToken = localStorage.getItem('zoy_auth_token')
      if (!authToken) {
        console.warn('Missing auth token, skipping FCM registration')
        return
      }

      if (typeof window === 'undefined' || !('Notification' in window)) {
        return
      }

      if (Notification.permission === 'denied') {
        console.warn('Notifications are blocked in this browser')
        return
      }

      if (Notification.permission === 'default') {
        const permission = await Notification.requestPermission()
        if (permission !== 'granted') return
      }

      const token = await requestForToken()
      if (token) {
        console.log('FCM Token:', token)
        // Send token to backend
        try {
          const response = await fetch(buildBackendUrl('/api/push/register'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({ token, deviceType: 'web' }),
          })
          if (!response.ok) {
            console.error('Failed to register FCM token with backend')
          }
        } catch (error) {
          console.error('Error registering FCM token:', error)
        }
      }
    }

    setupFCM()

    const unsubscribe = onMessageListener((payload) => {
      console.log('Message received in foreground:', payload)
      toast(payload.notification.title, {
        description: payload.notification.body,
      })
    })

    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe()
      }
    }
  }, [userId])
}
